<div class="modal-header">
  <h3 uni-heading color="primary" class="modal-title">Seleccion de Dashboard</h3>

  <button uni-icon-button variant="muted" aria-label="Cerrar" (click)="IsFromConfiguration ? closeModal() : saveSelection()">
    <uni-icon name="x"></uni-icon>
  </button>
</div>
<div class="modal-body">
  <p class="modal-text">Elija el panel principal que desea visualizar al cargar la página de inicio.</p>
  <div class="radio-list">
    <uni-radio-group [(ngModel)]="selectDashboardBind">
      <uni-radio-button
        *ngFor="let option of OptionArray"
        [value]="option?.url"
        styleVariant="modern"
        [checkedValue]="selectDashboardBind"
        [name]="option?.nombre"
        >{{ option?.nombre }}</uni-radio-button
      >
    </uni-radio-group>
  </div>
</div>

<div class="modal-footer" *ngIf="IsFromConfiguration">
  <button uni-button fill="outline" variant="secondary" (click)="closeModal()">Cancelar</button>
  <button uni-button (click)="saveSelection()">Guardar</button>
</div>
